import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { migrateLegacyPropertyCheck } from "../../lib/propertyCheckNavigation";

/** Handles old in-app links without mounting a lookup or its telemetry on the raw URL. */
export function LegacyPropertyCheckRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  useLayoutEffect(() => {
    const migrated = migrateLegacyPropertyCheck(location.pathname, location.search, location.state);
    if (migrated) {
      void navigate(`${location.pathname}${migrated.search}${location.hash}`, {
        replace: true,
        state: migrated.state,
      });
    }
  }, [location, navigate]);
  return null;
}
